export const KeysEnum = {
  APP: "axle_app",
  CREATE_DEFAULT_APP_RULE: "axle_create_default_app_rule",
  LAST_ACTIVE: "axle_last_active",
  SELECTED_ORG_DOCUMENT_ID: "axle_selected_org_document_id",
  TOKEN: "axle_token",
  TOKEN_RENEW: "axle_token_renew",
  // Namespaced Okta token bucket for the Axle SPA; shared by the OktaAuth
  // tokenManager config (~/services/okta) and the reader below so they can't
  // drift. Keeps other SPAs on this origin (e.g. TW Auth at /tw-auth) from
  // overwriting Axle's tokens in the okta-auth-js default "okta-token-storage".
  OKTA_TOKEN_STORAGE: "okta-axle-token-storage",
};
